import {
  getSortSignalenOptions,
  SorteringRichting,
  type SorteringType,
} from '@/components/sidebar/sortField/useSorting';

const sortSignalenOptions = getSortSignalenOptions();
const defaultSortType = sortSignalenOptions[0];
const defaultValueSortDirection = SorteringRichting.DOWN;

export type SignalenFilter = {
  eenheidOfTreinnummer?: string;
  dienstregelpunten?: string[];
  materieelTypen?: string[];
  signaalTypen?: string[];
  ingeregeldMat?: boolean;
  alleenManco?: boolean;
  alleenWts?: boolean;
  sorteringType?: SorteringType;
  sorteringRichting?: SorteringRichting;
};

export const defaultFilter = {
  sorteringType: defaultSortType.value,
  sorteringRichting: defaultValueSortDirection,
} satisfies SignalenFilter;
